import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import {filterCaseInsensitive, getTableState, setDefaultTableSort} from '../shared/tableFunctions';
import '../shared/react-table.css';

/**
 * The ReactTableContainer component accepts props from List containers, and converts the data for display in a
 * React Table.
 *
 */
class ListTableContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableArray: [],
            tableData: []
        };
    }

    componentDidMount() {
        this.setState({
            tableArray: [],
            tableData: []
        }, () => {
            this.processData();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (
            JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data) ||
            nextProps.ids !== this.props.ids ||
            nextProps.currentSort !== this.props.currentSort
        ) {
            this.setState({
                tableArray: [],
                tableData: []
            }, () => {
                this.processData();
            });
        }
    }

    /**
     * Process received data and convert to an array
     *
     */
    processData = () => {
        const data = JSON.parse(JSON.stringify(this.props.data));
        const ids = JSON.parse(JSON.stringify(this.props.ids));
        const keys = Object.keys(data);

        // Convert data array to array of ID objects
        let tableArray = [];
        if (keys && keys.length > 0) {
            keys.forEach(function (key) {
                const inIds = ids.findIndex(r => r.toString() === key.toString());
                if (key && key !== '' && (inIds !== -1)) {
                    const item = data[key];
                    if (item) {
                        tableArray.push(item);
                    }
                }
            });
        }
        this.setState({
            tableArray: tableArray,
            tableData: tableArray
        },() => {
        });
    };

    /**
     * Generate columns for ReactTable
     *
     * @param tableData
     *
     * @return {Array}
     */
    createTableColumns = (tableData) => {
        let columns = [];
        const children = this.props.columns;
        if (children && children.length > 0) {
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                // If table is generated by a filter, some columns may be unneeded
                if (child.hideOnFilter && child.hideOnValue.length) {
                    let skip = false;
                    for (let h = 0; h < child.hideOnValue.length; h++) {
                        if (this.props.filterValues[child.hideOnFilter] === child.hideOnValue[h]) {
                            skip = true;
                        }
                    }
                    if (skip) {
                        continue;
                    }
                }
                if (child.hideOnSecondaryFilter && child.hideOnSecondaryValue.length) {
                    let skip = false;
                    for (let h = 0; h < child.hideOnSecondaryValue.length; h++) {
                        if (this.props.filterValues[child.hideOnSecondaryFilter] === child.hideOnSecondaryValue[h]) {
                            skip = true;
                        }
                    }
                    if (skip) {
                        continue;
                    }
                }
                const style = (child.style) ? child.style : {};
                const column = {
                    Header: child.label,
                    accessor: child.source,
                    style: style,
                    headerStyle: style
                };
                const basePath = this.props.basePath;
                const resource = this.props.resource;

                // Set specific column attributes if they exist
                if (child.filterable === false) {
                    column.filterable = false;
                }
                if (child.filterMethod) {
                    column.filterMethod = child.filterMethod
                }
                if (child.sortable === false) {
                    column.sortable = false;
                }
                if (child.sortMethod) {
                    column.sortMethod = child.sortMethod
                }
                if (child.width) {
                    column.width = child.width;
                }

                // If a custom component is needed for this cell:
                if (child.component) {
                    column.Cell = (row) => (
                        React.cloneElement(child.component, {record: row.row, basePath, resource})
                    );
                }
                if (child.Expander) {
                    column.Expander = child.Expander;
                }
                if (child.expander) {
                    column.expander = true;
                }
                columns.push(column);
            }
        }
        return columns;
    };

    /**
     * Update selected ReactTable data based on sort or filter
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange = (event, table) => {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                tableData: tableData
            });
        }
    };

    render() {
        const {
            currentSort,
            perPage,
            subComponent
        } = this.props;

        const {
            tableArray,
            tableData
        } = this.state;

        const columns = this.createTableColumns(tableData);
        const defaultSort = (currentSort) ? setDefaultTableSort(currentSort) : null;
        const pageSize = (perPage) ? perPage : 10000;

        return (
            <div className="list-table-container">
                {tableArray.length > 0 &&
                <ReactTable
                    key="table-list"
                    data={tableArray}
                    columns={columns}
                    defaultPageSize={pageSize}
                    showPagination={true}
                    defaultSorted={defaultSort}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    onSortedChange={(e) => this.handleSortOrFilterChange(e, this.reactTable)}
                    onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.reactTable)}
                    ref={(r) => this.reactTable = r}
                    resizable={false}
                    minRows={0}
                    className="-striped overflow"
                    SubComponent={subComponent}
                />
                }
            </div>
        );
    }
}

ListTableContainer.propTypes = {
    basePath: PropTypes.string,
    columns: PropTypes.array,
    currentSort: PropTypes.shape({
        sort: PropTypes.string,
        order: PropTypes.string,
    }),
    data: PropTypes.object.isRequired,
    ids: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool,
    options: PropTypes.object,
    perPage: PropTypes.number,
    resource: PropTypes.string,
    styles: PropTypes.object,
    subComponent: PropTypes.any
};

ListTableContainer.defaultProps = {
    columns: [],
    data: {},
    ids: [],
    perPage: 10,
    subComponent: null
};

export default ListTableContainer;



// WEBPACK FOOTER //
// ./src/Fuse/components/ListTableContainer.js